module.exports = function(value) {
  return (value && 'Yes') || 'No';
};
